export const mergeChallengeStepsAndCompletions = (steps, completionsSteps) => {
  const completionIdAndDateMap = Object.fromEntries(
    completionsSteps.map((step) => {
      return [Number(step.stepId), step.completedAt];
    })
  );

  const formattedSteps = steps.map((step) => {
    const completedAt = completionIdAndDateMap[step.id] || null;

    return {
      ...step,
      completedAt: completedAt ? new Date(completedAt).toISOString() : null,
    };
  });

  /** NOTE(apoorvyadav1|SPD-12512|2025-06-16): There can be multiple cart requirements for each step,
   * and each cart requirement can have multiple items including duplicates. We need to format the cart requirements
   * to ensure that each item is unique and formatted as "quantity × name".
   */
  const formattedStepsWithUniqueCartRequirements = formattedSteps.map((step) => {
    const uniqueCartRequirements = step.cartRequirements?.map((cartRequirement) => {
      return [...new Set(cartRequirement.map((item) => `${item.quantity} × ${item.name}`))];
    });

    return { ...step, cartRequirements: uniqueCartRequirements };
  });

  return formattedStepsWithUniqueCartRequirements;
};
